import { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext();

const RATES = {
  INR: 1,
  USD: 0.0109,
  EUR: 0.0093,
  CNY: 0.072,
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(
    localStorage.getItem("currency") || "INR"
  );

  useEffect(() => {
    localStorage.setItem("currency", currency);
  }, [currency]);

  const convertPrice = (priceInINR) => {
    if (priceInINR == null) return 0;

    const numericPrice = Number(String(priceInINR).replace(/[^\d.]/g, ""));
    if (isNaN(numericPrice)) return 0;

    const rate = RATES[currency] || 1;
    return numericPrice * rate;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convertPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
